import { modalStyle } from '../../styles/global.styles';
import Modal from '@mui/material/Modal';
import Card from '@mui/material/Card';
import { ReactNode } from 'react';
import { Box, Grid2 } from '@mui/material';
import {
  CSSSelectorObjectOrCssVariables,
  GridSize,
  ResponsiveStyleValue,
} from '@mui/system';

interface ModalComponentProps {
  children: ReactNode;
  onClose: (event: any, reason: any) => void;
  isOpen: boolean;
  width?: number | string;
  title?: string;
  cardContainerStyle?: CSSSelectorObjectOrCssVariables;
  height?: number;
  additionalTopRightComponent?: ReactNode;
  additionalTopRightComponentSize?: ResponsiveStyleValue<GridSize>;
  hideBackdrop?: boolean;
}

const ModalComponent = ({
  children,
  isOpen,
  onClose,
  width,
  height,
  title,
  hideBackdrop,
  cardContainerStyle,
  additionalTopRightComponent,
  additionalTopRightComponentSize,
}: ModalComponentProps) => {
  return (
    <Modal open={isOpen} onClose={onClose} hideBackdrop={hideBackdrop}>
      <Card
        sx={[
          modalStyle,
          { width: width ?? 800, height: height ?? 'auto' },
          cardContainerStyle ? cardContainerStyle : {},
        ]}
        color="primary"
      >
        <Grid2
          container
          columnSpacing={1}
          style={{
            display: additionalTopRightComponent ? 'flex' : 'block',
            justifyContent: 'space-between',
          }}
          mb={1}
        >
          <Grid2 size={additionalTopRightComponent ? 6 : 12}>
            {title && <h2 id="parent-modal-title">{title}</h2>}
          </Grid2>
          {additionalTopRightComponent && (
            <Grid2
              size={
                additionalTopRightComponentSize
                  ? additionalTopRightComponentSize
                  : 6
              }
            >
              <Box sx={{ mt: 3, width: '100%' }}>
                {additionalTopRightComponent}
              </Box>
            </Grid2>
          )}
        </Grid2>
        {children}
      </Card>
    </Modal>
  );
};

export default ModalComponent;
